import React from "react";
import { withNavBars } from "../../HOCs";
import { Leads } from "./leads";
import CreateLeadContext from "./leadcontext";
class LeadsParent extends React.Component {
  render() {
    return (
      <CreateLeadContext>
        <Leads />
      </CreateLeadContext>
    );
  }
}
const props = {
  boxShadow: false
}
export default withNavBars(LeadsParent, props);
